import React from 'react'
import { Badge } from 'evergreen-ui'
import { FaCheck } from 'react-icons/fa'

const StatusRegister_2 = () => {
  return (
    <Badge
      color="green"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={16}
      fontFamily=""
    >
      <FaCheck /> เข้ารับการสอบสัมภาษณ์
    </Badge>
  )
}

export default StatusRegister_2